export const queryKeys = {
  fleet: {
    summary: ['fleet', 'summary'] as const,
  },
  devices: {
    all: ['devices'] as const,
    list: (filters: Record<string, unknown>) => ['devices', 'list', filters] as const,
    detail: (id: string) => ['devices', 'detail', id] as const,
    snapshots: (id: string) => ['devices', 'snapshots', id] as const,
    config: (id: string) => ['devices', 'config', id] as const,
  },
  detections: {
    all: ['detections'] as const,
    list: (filters: Record<string, unknown>) => ['detections', 'list', filters] as const,
    detail: (id: string) => ['detections', 'detail', id] as const,
  },
  artifacts: {
    meta: (detectionId: string) => ['artifacts', 'meta', detectionId] as const,
    timeline: (detectionId: string) => ['artifacts', 'timeline', detectionId] as const,
    dom: (detectionId: string, index: number) => ['artifacts', 'dom', detectionId, index] as const,
    flows: (detectionId: string) => ['artifacts', 'flows', detectionId] as const,
  },
  rules: {
    all: ['rules'] as const,
    list: () => ['rules', 'list'] as const,
    detail: (id: string) => ['rules', 'detail', id] as const,
    bundle: () => ['rules', 'bundle'] as const,
  },
  settings: {
    all: ['settings'] as const,
    integrations: () => ['settings', 'integrations'] as const,
    apiKeys: () => ['settings', 'api-keys'] as const,
  },
} satisfies Record<string, Record<string, unknown>>
